import {PieChart, Pie, Cell, Tooltip} from 'recharts';
import React from "react";
import {Money} from "../../../common";
import {formatPercents} from "../../../../formatters";
import {formatAmount} from "utils";
import styles from './DonutChart.module.scss';
import {useMyMoneyData} from "../../../../hooks/useMyMoneyData";

const DonutChart = () => {
  const {totalSum, inLoanProjects, free, reserved} = useMyMoneyData().balanceStats;
  const data = [
    {name: 'Свободно', value: free.amount, color: '#E7EDE8'},
    {name: 'Бронировано', value: reserved.amount, color: '#00703E'},
    {name: 'В сделках', value: inLoanProjects.amount, color: '#68A4FE'},
  ];
  return (
    <div>
      <Money money={totalSum} />
      <p>всего денег на платформе</p>
      <div className={styles.chartContainer}>
        <PieChart width={120} height={120}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={30}
            outerRadius={60}
            fill="#8884d8"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color}/>
            ))}
          </Pie>
          <Tooltip formatter={(value: any) => `${formatAmount(Number(value) / 100, {decimalDelimiter: ","})} ₽`}/>
        </PieChart>
        <div>
          {data.map((entry, index) => (
            <div key={index} className={styles.legendItem}>
              <div
                className={styles.colorIndicator}
                style={{backgroundColor: entry.color}}
              ></div>
              <div className={styles.legendText}>
                <div>
                  {entry.name} ({formatPercents((entry.value / totalSum.amount) * 100)})
                </div>
                <Money money={{amount: entry.value, currencyCode: 'RUB'}} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DonutChart;